import React, { useEffect, useState } from "react";
import TopBar from "../features/FeatureTopBar/components/TopBar";
import { show_proper_words } from "../../utils/Constant";
import AddorEditInternalExternalUsers from "./components/AddorEditInternalExternalUsers";
import {
  delete_user,
  invitation_resend,
  invitations_sent_by_client,
} from "../../DAL/manage-users/manage-users";
import { useIds } from "../../hook/AdminContext";
import { enqueueSnackbar } from "notistack";
import CircularLoader from "../../components/loader/CircularLoader";
import CustomMUITable from "../../components/customtable/CustomMuiTable";
import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import AppliedFilters from "../../components/AppliedFilters/AppliedFilters";
import GeneralMUIDialog from "../../components/GeneralMUIDialog/GeneralMUIDialog";
import ResponseFieldFilter from "../../components/ResponseFieldFilter/ResponseFieldFilter";
import { Funnel } from "lucide-react";
import UpgradeModal from "../../components/popUp/UpgradeModal";
import { useNavigate } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { search_blue_icon, select_icon } from "../../assets";

const topBarList = [
  {
    id: "external",
    title: "External Users",
  },
  {
    id: "internal",
    title: "Internal Users",
  },
];

export default function ManageProfile() {
  const {
    userInfo,
    setUserInfo,
    setUserAPIData,
    setUpdateUsersOnNotification,
  } = useIds();
  const navigate = useNavigate();
  const [tabToOpen, setTabToOpen] = useState("external");
  const [invitationsList, setInvitationsList] = useState([]);
  const [totalInvitations, setTotalInvitations] = useState([]);
  const [openAddEditDialog, setOpenAddEditDialog] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [resendConfirmation, setResendConfirmation] = useState(false);
  const [targetInvitation, setTargetInvitation] = useState(null);
  const [loading, setLoading] = useState(false);

  const [openUpgradeModal, setOpenUpgradeModal] = useState(false);

  // seacrh and pagination
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchInputValue, setSearchInputValue] = useState("");

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchText(searchInputValue);
      setPage(0);

      handleGetSentInvitation(filterData, {
        page: 0,
        limit: rowsPerPage,
        search: searchInputValue,
      });
    }, 800); // debounce delay

    return () => clearTimeout(handler);
  }, [searchInputValue]);


  const searchFunction = (e) => {
    e.preventDefault();
    setLoading(true);
    setPage(0);
    handleGetSentInvitation(filterData, {
      page: 0,
      limit: rowsPerPage,
      search: searchText,
    });
  };

  const handleChangePage = (event, newPage) => {
    setLoading(true);
    setPage(newPage);
    handleGetSentInvitation(filterData, {
      page: newPage,
      limit: rowsPerPage,
      search: searchText,
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setLoading(true);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    handleGetSentInvitation(filterData, {
      page: 0,
      limit: parseInt(event.target.value, 10),
      search: searchText,
    });
  };
  // filter states
  const [filterModal, setFilterModal] = useState(false);
  const [appliedFilterData, setAppliedFilterData] = useState(null);
  const [filterChange, setFilterChange] = useState(false);
  const [filterData, setFilterData] = useState(null);

  const handleAddUser = () => {
    if (totalInvitations < 4) {
      setTargetInvitation(null);
      setOpenAddEditDialog(true);
    } else {
      setOpenUpgradeModal(true);
    }
  };

  const handleGetSentInvitation = async (
    obj = null,
    pagination = {
      page: page,
      limit: rowsPerPage,
      search: searchText,
    }
  ) => {
    setLoading(true);
    const resp = await invitations_sent_by_client(
      userInfo?.profile_id,
      tabToOpen,
      obj?.response?.value || "",
      pagination.page,
      pagination.limit,
      pagination.search
    );
    if (resp.code == 200) {
      setAppliedFilterData(obj);
      setInvitationsList(resp.data.invitation);
      setTotalInvitations(resp.data.total_invitation || 0);

      setTotalCount(resp.data?.count);
      setTotalPages(Math.ceil(resp.data?.total_page - 1));
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (userInfo?.profile_id) {
      handleGetSentInvitation(null, {
        page: 0,
        limit: 50,
        search: "",
      });
      setPage(0);
      setSearchText("");
      setRowsPerPage(50);
      setFilterData(null);
    }
  }, [userInfo?.profile_id, tabToOpen]);

  const handleAgreeDelete = (obj) => {
    setTargetInvitation(obj);
    setOpenDelete(true);
  };

  const handleEdit = (obj) => {
    setTargetInvitation(obj);
    setOpenAddEditDialog(true);
  };

  const handleDelete = async () => {
    const resp = await delete_user(targetInvitation._id);
    if (resp.code == 200) {
      enqueueSnackbar(resp.message, { variant: "success" });
      if (targetInvitation.email == userInfo.email) {
        setOpenDelete(false);
        navigate("/validate-profile");
        return;
      }
      handleGetSentInvitation(filterData);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setOpenDelete(false);
  };

  const resendInvitation = async (obj) => {
    setTargetInvitation(obj);
    setResendConfirmation(true);
  };

  const handleResendInvitation = async () => {
    const resp = await invitation_resend(targetInvitation._id);
    if (resp.code == 200) {
      enqueueSnackbar(resp.message, { variant: "success" });
      handleGetSentInvitation(filterData);
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setResendConfirmation(false);
  };

  const handleDetailPopUp = (obj) => { };

  const handleFilterData = () => {
    setFilterModal(false);
    handleGetSentInvitation(filterData);
  };
  const findObjectWithId = (id, list) => {
    return list.find((obj) => obj.value == id) || null;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    let obj =
      value === "all"
        ? null
        : findObjectWithId(value, typesList);

    const updatedFilter = { [name]: obj };

    setFilterData(updatedFilter);
    setAppliedFilterData(updatedFilter);

    // reset pagination
    setPage(0);
    setLoading(true);

    // 🔥 direct API call
    handleGetSentInvitation(updatedFilter, {
      page: 0,
      limit: rowsPerPage,
      search: searchText,
    });
  };

  const typesList = [
    {
      value: "accepted",
      title: "Accepted",
    },
    {
      value: "pending",
      title: "Pending",
    },
    {
      value: "rejected",
      title: "Rejected",
    },
  ]
  const TABLE_HEAD = [

    { id: "number", label: "Sr.", type: "number" },
    { id: "email", label: "Email", className: "email-bold" },

    { id: "user_type", label: "Type", className: "text-capitalize" },
    // {
    //   id: "invitation_response",
    //   label: "Status",
    //   className: "text-capitalize",
    //   type: "string_status",
    //   chipColor: (value) => {
    //     console.log(value, "hiii")
    //     return value == "pending"
    //       ? "info"
    //       : value == "accepted"
    //         ? "success"
    //         : "error";
    //   },
    // },
    {
      id: "invitation_response",
      label: "Status",
      className: "text-capitalize",
      type: "type_status",
      chipClass: (value) => {
        switch (value) {
          case "pending":
            return "status-chip status-pending";
          case "accepted":
            return "status-chip status-accepted";
          case "rejected":
            return "status-chip status-rejected";
          default:
            return "status-chip status-chip";
        }
      },
    },


    //  {
    //   id: "invitation_response",
    //   label: "Status",
    //   type: "custom",
    //   render: (value) => (
    //     <div className={`status-chip ${value}`}>
    //       {value}
    //     </div>
    //   ),
    // },
    {
      id: "action",
      label: "Action",
      type: "action",
      MENU_OPTIONS: (row) => {
        let array = [
          // {
          //   label: "View Details",
          //   icon: "bxs:detail",
          //   handleClick: handleDetailPopUp,
          // },
          {
            label: "Edit Access",
            icon: "akar-icons:edit",
            handleClick: handleEdit,
          },
        ];

        if (row.invitation_response == "rejected") {
          array.push({
            label: "Resend Invitation",
            icon: "pajamas:retry",
            handleClick: resendInvitation,
          });
        }
        array.push({
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: handleAgreeDelete,
        });
        return array;
      },
    },
  ];

  const handleUpdateSpecificUser = (
    updatedUser,
    setList = setInvitationsList
  ) => {
    setList((prev) =>
      prev.map((item) =>
        item._id === updatedUser._id ? { ...item, ...updatedUser } : item
      )
    );
  };

  useEffect(() => {
    // Register the function
    setUpdateUsersOnNotification(() => (data) => {
      handleUpdateSpecificUser(data, setInvitationsList);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateUsersOnNotification(() => () => { });
    };
  }, [invitationsList]);

  return (
    <>
      {openAddEditDialog && (
        <AddorEditInternalExternalUsers
          openAddEditDialog={openAddEditDialog}
          setOpenAddEditDialog={setOpenAddEditDialog}
          type={tabToOpen}
          handleGetSentInvitation={() => handleGetSentInvitation(filterData)}
          targetInvitation={targetInvitation}
        />
      )}

      {openDelete && (
        <CustomConfirmation
          openDelete={openDelete}
          setOpenDelete={setOpenDelete}
          title={"Are you sure you want to delete this User?"}
          headerHeading={"Delete User"}
          handleAgree={handleDelete}
          infoTitle={"Warning"}
          additionalInfo={
            userInfo.email === targetInvitation.email
              ? `You are attempting to delete your own account. ${userInfo.role === "internal_user"
                ? "If you proceed, your account will be permanently deleted."
                : "If you proceed, your current session will be expired."
              }`
              : ""
          }
        />
      )}

      {/* {filterModal && (
        <GeneralMUIDialog
          open={filterModal}
          setOpen={setFilterModal}
          actionText="Filter"
          title="Filter"
          content={
            <ResponseFieldFilter
              inputs={filterData}
              setInputs={setFilterData}
            />
          }
          onSubmit={handleFilterData}
        />
      )} */}

      {resendConfirmation && (
        <CustomConfirmation
          open={resendConfirmation}
          setOpen={setResendConfirmation}
          title={"Are you sure you want to resend invitation?"}
          headerHeading={"Resend Invitation"}
          handleAgree={handleResendInvitation}
        />
      )}

      {/* Upgrade Modal */}
      {openUpgradeModal && (
        <UpgradeModal
          open={openUpgradeModal}
          handleClose={() => setOpenUpgradeModal(false)}
          islimitExceedModal={true}
        />
      )}
      <div className="container-fluid mt-3  manage-heading">
        <div className="row mt-0">
          <div className="col-12 heading-main">
            <h2>Manage Users</h2>
            <p>Streamline the management of users and their permissions.</p>
          </div>
          <div className="col-12">
            <TopBar
              classes="tw-w-[300px]"
              items={topBarList}
              cardToOpen={tabToOpen}
              setCardToOpen={(value) => {
                setTabToOpen(value);
              }}
            />
          </div>

          <div className="col-12 profile-card my-3 my-lg-4">
            <div className="row justify-content-between align-items-center">
              <div className="col-md-3 col-lg-4 mb-3 mb-md-0">
                <h5 className="mb-0">{show_proper_words(tabToOpen)} Users</h5>
              </div>

              <div className="col-md-9 col-lg-8">
                {/* <div
                  className="me-2 pointer d-flex  align-items-center justify-content-center"
                  style={{
                    height: 38,
                    width: 38,
                  }}
                  onClick={() => setFilterModal(true)}
                >
                  <Funnel className="tw-h-4 tw-w-4" />
                </div> */}
                <div className="custom-input-design d-flex align-items-center  justify-content-md-end">

                  <div className="position-relative  mt-2 mt-md-0">
                    <input
                      className="ps-5"
                      placeholder={"Search..."}
                      value={searchInputValue}
                      onChange={(e) => setSearchInputValue(e.target.value)}
                    />

                    <img
                      src={search_blue_icon}
                      className="input-start-icon"
                      alt=""
                    />
                  </div>
                  <div className="position-relative ms-1 ms-md-3 mt-2 mt-md-0">
                    <select
                      labelId="sector-select-response"
                      id="sector-select-response"
                      value={filterData?.response?.value || "all"}
                      required
                      className="ps-3 cursor-pointer"
                      name="response"
                      label="Response Type"
                      onChange={(e) => handleChange(e)}
                    >
                      <option key={"All"} value={"all"}>
                        {"All"}
                      </option>

                      {typesList.map((type) => (
                        <option key={type.value} value={type.value}>
                          {type.title}
                        </option>
                      ))}
                    </select>
                    <img
                      src={select_icon}
                      className="input-end-icon pe-none"
                      alt=""
                    />
                  </div>
                  <button
                    className="small-button-cotain-view-all ms-1 ms-md-3 mt-2 mt-md-0"
                    onClick={() => handleAddUser()}
                  >
                    Invite User
                  </button>
                </div>


              </div>
            </div>
          </div>

          {loading ? (
            <>
              <CircularLoader />
            </>
          ) : (
            <>
              {appliedFilterData && (
                <div>
                  <AppliedFilters
                    filterData={appliedFilterData}
                    setFilterData={setFilterData}
                    onFilterChange={(data) => {
                      handleGetSentInvitation(data);
                    }}
                  />
                </div>
              )}

              <div className="col-12 custome-table-style">
                <CustomMUITable
                  TABLE_HEAD={TABLE_HEAD}
                  data={invitationsList}
                  // pagePagination={true}
                  is_hide={true}
                  custom_pagination={{
                    total_count: totalCount,
                    rows_per_page: rowsPerPage,
                    page: page,
                    handleChangePage: handleChangePage,
                    onRowsPerPageChange: handleChangeRowsPerPage,
                  }}
                  totalPages={totalPages}
                // custom_search={{
                //   searchText: searchText,
                //   setSearchText: setSearchText,
                //   handleSubmit: searchFunction,
                // }}
                />
              </div>
            </>
          )}
        </div>
      </div >
    </>
  );
}
